import { FC, useEffect } from 'react'
import { t } from 'i18next'

import InteractionBase from '../../common/components/InteractionBase'
import Layout from '../../common/components/Layout'
import { getResultComponent } from '../../common/utils/result'
import { ResultType } from '../../types/Result'
import MultipleResults from './MultipleResults/MultipleResults'
import { authFetch } from '../../common/utils/cognito'
import { ResultFeed } from '../../types/Feed'
import { getDetectedLanguage } from '../../i18n'

interface ResultProps {
  result: ResultFeed
}

const ResultContent: FC<ResultProps> = ({ result }) => {
  const { content: data } = result
  const { results } = data

  const validResults = results.filter((result) => {
    return (
      result.type === ResultType.MULTIPLE_CHOICE ||
      result.type === ResultType.SCALE ||
      result.type === ResultType.OPEN_TEXT ||
      result.type === ResultType.TEXT ||
      result.type === ResultType.CHALLENGE ||
      (result.type === ResultType.INSIGHT && result.header)
    )
  })

  const isMultipleResults = validResults.length > 1

  useEffect(() => {
    if (validResults.length === 0) {
      return
    }

    authFetch(
      `${process.env.REACT_APP_API_URL}/user-exercises/${data.id}/result-viewed`,
      {
        method: 'POST',
      },
    )
  }, [data, validResults])

  // avoid rendering when have AUDIO results. Need to be removed when unnecessary results are removed from the API
  if (validResults.length === 0) return null

  return (
    <Layout>
      {isMultipleResults ? (
        <MultipleResults results={validResults} title={result.title} />
      ) : (
        <InteractionBase
          title={result.title[getDetectedLanguage()]}
          subtitle={t('results.reflection')}
        >
          {getResultComponent(validResults[0])}
        </InteractionBase>
      )}
    </Layout>
  )
}

export default ResultContent
